<template>
    <CieloLayout layout-version="v1">
        <div class="container text-center mt-5">
            <h1 class="error-title" tabindex="0">
                404
            </h1>
            <h2 class="error-subtitle mt-3" tabindex="0">
                Ooops, página não encontrada.
            </h2>
        </div>
    </CieloLayout>
</template>

<script>
const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
);

export default {
    components: {
        CieloLayout
    }
};
</script>

<style lang="scss" scoped>
.error-title {
    font-size: 50px;
    font-weight: 700;
    color: $cielo-blue;
}

.error-subtitle {
    font-size: 25px;
    font-weight: 300;
    color: $cielo-blue;
}

.error-description {
    color: #5d666b;
}
</style>